import { UniqueSelectionDispatcherListener } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PaginationHeaderData } from 'src/app/models/pagination-header-data.model';
import { UserNotification } from 'src/app/models/user-notification.model';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { UserNotificationService } from 'src/app/services/user-notification.service';
import { UpdateNotifications } from 'src/app/store/actions/shopping.actions';
import { AppState } from 'src/app/store/models/app-state.model';
import { MatIcon } from "@angular/material/icon";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { MatCheckbox } from "@angular/material/checkbox";
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'app-notifications-management',
	templateUrl: './notifications-management.component.html',
	styleUrls: ['./notifications-management.component.scss'],
 imports: [MatIcon, MatTabGroup, MatTab, MatCheckbox, DatePipe, MatButtonModule]
})
export class NotificationsManagementComponent implements OnInit {
	notifications: UserNotification[] = [];
	currentIsReadTab: boolean = false;
	currentPage: number = 1;
	moreNotificationsToLoad: boolean = true;

	constructor(
		private tokenStorageService: TokenStorageService,
		private notificationService: UserNotificationService,
		private store: Store<AppState>,
	) { }

	ngOnInit() {
		this.getNotifications(this.currentIsReadTab);
	}

	getNotifications(isRead: boolean): void {
		const queryParams = new Map([
            ["isRead", isRead.toString()],
            ["pageNumber", this.currentPage.toString()],
			['userId', this.tokenStorageService.getUser().id]
        ]);
		this.notificationService.getPaginatedNotifications([], queryParams).subscribe((result) => {
			let paginationData: PaginationHeaderData = JSON.parse(result.headers.get('x-pagination'));
			this.moreNotificationsToLoad = paginationData.hasNext;
			this.notifications = [...this.notifications ,...result.body];
			this.updateNotificationCounter();
		});
	}

	updateNotificationCounter(): void {
		const queryParams = new Map([
            ["isRead", 'false'],
            ["pageNumber", this.currentPage.toString()],
			['userId', this.tokenStorageService.getUser().id]
        ]);
		this.notificationService.getPaginatedNotifications([], queryParams).subscribe((result) => {
			let paginationData: PaginationHeaderData = JSON.parse(result.headers.get('x-pagination'));
			this.store.dispatch(new UpdateNotifications(paginationData.totalCount));
		});
	}

	tabChange(): void {
		this.notifications = [];
		this.currentPage = 1;
		this.currentIsReadTab = !this.currentIsReadTab;
		this.getNotifications(this.currentIsReadTab);
	}

	updateNotification(notification: UserNotification): void {
		notification.isRead = !notification.isRead;
		this.notifications = this.notifications.filter(x => x.notificationId != notification.notificationId)
		this.notificationService.put([notification.notificationId], notification).subscribe(() => {
			this.updateNotificationCounter();
		});
	}

	loadMoreNotifications(): void {
		this.currentPage++;
		this.getNotifications(this.currentIsReadTab);
	}
}
